import ProductBookmark from '@ulta/components/ProductBookmark/ProductBookmark';

export default ProductBookmark;